import React from 'react';
import Select from 'react-select';
import { FaTimes } from 'react-icons/fa';
import FormControl from 'react-bootstrap/FormControl';

import Const from '../../util/Constants';
import FieldController from '../../controller/FieldController';

class FilterNumber extends React.Component {

  constructor(props) {
    super(props);
    const filter = props.filter;
    this.conditions = FieldController.getConditions(props.field.field_type);
    let condition = filter ? filter.condition : FieldController.In;
    condition = this.conditions.find(item => condition === item.value);
    this.state = { condition: condition, from: '', to: '' };
  
    if(filter && filter.value !== '') {
      let values = props.filter.value.split(Const.Opt);
      if(values[0] !== '') { this.state.from = parseInt(values[0]); }
      if(values[1] !== '') {  this.state.to = parseInt(values[1]); }
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.field.field_key !== this.props.field.field_key) {
      const filter = props.filter;
      let condition = filter ? filter.condition : FieldController.In;
      condition = this.conditions.find(item => condition === item.value);
    
      let from = '', to = ''; 
      if(filter && filter.value !== '') {
        let values = filter.value.split(Const.Opt);
        if(values[0] !== '') { from = parseInt(values[0]); }
        if(values[1] !== '') {  to = parseInt(values[1]); }
      }
      this.setState({ ...this.state, condition, from: from, to: to });
    }
  }

  onConditionChanged = select => {
    this.setState({ ...this.state, condition: select, from: '', to: '' });
    if(select.value === FieldController.Empty || select.value === FieldController.NotEmpty) {
      this.props.onValueChange(this.props.field.field_key, select.value, '', this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.field_key, this.props.field.model_key);
    }
  }

  onValueChange = (value, source) => {
    if(source === 'from') {
      this.setState({ ...this.state, from: value });
      value = `${value}${Const.Opt}${this.state.to}`;
    } else if(source === 'to') {
      this.setState({ ...this.state, to: value });
      value = `${this.state.from}${Const.Opt}${value}`;
    }
    this.props.onValueChange(this.props.field.field_key, this.state.condition.value, value, this.props.field.model_key);
  }

  render() {
    const condition = this.state.condition ? this.state.condition.value : '';
    const isFilter = (this.state.from || this.state.to )
      || !(FieldController.showDateFrom(Const.Number, condition)
        && FieldController.showDateTo(Const.Number, condition));
    return (
      <>
        <div className="row pt-2">
          <div className="col-md-5">
            <p className="headingp">
              {this.props.field.model_key ? <>{this.props.field.model_name}<br/></> : ''}{this.props.field.label_name}
            </p>
          </div>
          <div className={`col-md-${isFilter ? 5: 7}`}>
            <Select value={this.state.condition} onChange={this.onConditionChanged}
              options={this.conditions} isSearchable={true} />
          </div>
          { isFilter ? <div className="col-md-1"><FaTimes 
              onClick={() => this.props.resetFilter(this.props.field.field_key)}/></div> : null }
        </div>

        <div className="row pt-2">
          { FieldController.showDateFrom(Const.Number, condition) ?
            <FormControl className="col-md-6" type="text" value={this.state.from} placeholder="Value" 
              onChange={event => this.onValueChange(event.target.value, 'from')} /> : null
          }
          { FieldController.showDateTo(Const.Number, condition) ?
            <FormControl className="col-md-6" type="text" value={this.state.to} placeholder="Value"
              onChange={event => this.onValueChange(event.target.value, 'to')} /> : null
          }
        </div>
        <hr />
      </>
    );
  }
}
export default FilterNumber;